import React from 'react'
import Card from 'atoms/surfaces/card/Card'
import CardMedia from 'atoms/surfaces/card/CardMedia'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import Skeleton from 'atoms/feedback/Skeleton'

export type EyeCatchingImageProps = {
  url?: string | null
}

const useStyles = makeStyles(theme => createStyles({
  eyeCatching: {
    height: '10rem',
    [theme.breakpoints.up('sm')]: {
      height: '15rem'
    },
    [theme.breakpoints.up('md')]: {
      height: '25rem'
    }
  }
}))

export default function EyeCatchingImage ({ url }: EyeCatchingImageProps) {
  const classes = useStyles()

  if (!url) {
    return <Skeleton className={classes.eyeCatching}/>
  }

  return (
    <Card>
      <CardMedia
        image={url}
        className={classes.eyeCatching}
        title="eye catching"
      />
    </Card>
  )
}
